/**
 * Router setup component for tests using React Router v6
 * Mirrors RouterSetup but uses MemoryRouter for testing
 */
import { RouteMapProvider } from "./RouteMapContext";
import { RouteDefinition } from "./types";
import React from "react";
import { MemoryRouter } from "react-router-dom";

interface RouterTestSetupProps {
  basename?: string;
  routes: RouteDefinition[];
  children: React.ReactNode;
  initialEntries?: string[];
  initialIndex?: number;
}

/**
 * Test router setup component
 * Wraps app with MemoryRouter and provides route name map
 * Use this in tests instead of RouterSetup
 *
 * @example
 * <RouterTestSetup
 *   routes={getRoutes({siteType: SITE_TYPES.WEDDING})}
 *   initialEntries={["/dashboard"]}
 * >
 *   <AppContainer />
 * </RouterTestSetup>
 */
export const RouterTestSetup: React.FC<RouterTestSetupProps> = ({
  basename = "",
  children,
  initialEntries = ["/"],
  initialIndex,
  routes,
}) => {
  return (
    <MemoryRouter
      basename={basename}
      initialEntries={initialEntries}
      initialIndex={initialIndex}
    >
      <RouteMapProvider routes={routes}>{children}</RouteMapProvider>
    </MemoryRouter>
  );
};
